import styled from 'styled-components';

export default styled.section`
  background-color: ${props => props.theme.colors.grey};
  padding: 1em;
  margin-bottom: ${props => (props.admin === true ? '0.25em' : '1em')};
`;
